import {SCLabeledInputComponent} from './components/sc-labeled-input/sc-labeled-input.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';

@NgModule({
    imports: [
        BDSharedModule,
        CommonModule,
        FormsModule
    ],
    declarations: [
        SCLabeledInputComponent,


    ],
    exports: [
        SCLabeledInputComponent

    ]
})
export class BDCSSharedModule {
}
